// extracted by mini-css-extract-plugin
export default {"container":"Actions_container__aMDvZ","caption":"Actions_caption__fF42s","title":"Actions_title__hBQCo","subtitle":"Actions_subtitle__fxm0X","closeIcon":"Actions_closeIcon__pMdHd"};